import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/App.css";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SiteProvider>
        <App />
        <Toaster position="top-center" theme="dark" richColors />
      </SiteProvider>
    </AuthProvider>
  </React.StrictMode>,
);
